/* unplugin-vue-components disabled */import script from "./UsersTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersTabs.vue?vue&type=script&setup=true&lang=js"

import "./UsersTabs.vue?vue&type=style&index=0&id=5fde3f64&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fde3f64"]])

export default __exports__